import stylesMediaText from '@components/media-text/MediaText.module.scss'
import { usePbProps } from '@content/helpers/src/context'
import { useState } from 'preact/hooks'
import { PlayIcon } from '../../icons/PlayIcon'
import styles from './ModalVideo.module.scss'

import Content from '@components/media-text/components/content/Content'
import Heading from '@components/media-text/components/heading/Heading'
import Visual from '@components/media-text/components/visual/Visual'
import { selectPromotion } from '@content/helpers/src/gtmEvents'
import { makeId } from '@content/helpers/src/utils.ts'
import { MediaModal } from '@nespresso-design-system/components'

export default function PlaceholderModalVideo() {
    const { copywriting, campaign }: any = usePbProps()

    const { title, description, image, modal, cta, cta_secondary } = copywriting

    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => {
        selectPromotion({
            cta_name: `VIDEO - 1 - Open Modal`,
            ...campaign
        })

        setIsOpen(true)
    }

    const closeModal = () => {
        setIsOpen(false)
    }

    const modalVideoId = `modal-${makeId(4)}`

    return (
        <>
            <div className={stylesMediaText['media-text__placeholder']}>
                <div
                    className={`${stylesMediaText['modal-video']} ${styles['modal-video']}`}>
                    <div className={styles['modal-video__placeholder']}>
                        <button
                            className={styles['play-icon']}
                            onClick={openModal}>
                            <PlayIcon fillRect="white" />
                            <span className="sr-only">Play</span>
                        </button>
                    </div>

                    <MediaModal
                        heroImgAlt={modal?.image?.desktop?.alt}
                        heroImgSrc={modal?.image?.desktop?.src}
                        heroImgRetinaSrc={modal?.image?.retina?.src}
                        heroVideoSrc={modal?.video?.url}
                        closeBtnA11yLabel={
                            modal?.translations?.closeBtnA11yLabel
                        }
                        id={modalVideoId}
                        heroAspectRatio="16/9"
                        isOpen={isOpen}
                        onClose={closeModal}
                    />

                    <Visual
                        alt_text={image?.desktop?.alt}
                        desktop={image?.desktop?.src}
                        mobile={image?.mobile?.src}
                        retina={image?.retina?.src}></Visual>
                </div>
            </div>
            <div className={stylesMediaText['media-text__content']}>
                <div>
                    <Heading title={title} />
                </div>
                <div>
                    <Content
                        campaign={campaign}
                        text={description}
                        buttonPrimary={cta}
                        buttonSecondary={cta_secondary}
                    />
                </div>
            </div>
        </>
    )
}
